module.exports = {
  type: 'VOD_VIDEO',
  rowTypeData: {
    background: {
      gradientLeft: false,
      gradientRight: false,
      gradientTop: false,
      gradientBottom: false,
      animationType: 'NONE',
    },
    title: 'New',
    rowCount: 1,
    rowType: 'BASIC',
    contentDescription: 'HIDE',
    focusStyle: 'NONE',
    playlistImageType: 'NONE',
    hideMetadata: false,
    videoDurationDisplayMode: 'SHOW',
  },
  name: 'New',
  exid: '4FHz',
  paging: {
    moreDataAvailable: false,
    lastSeen: '0:84274',
  },
  contentList: [
    {
      type: 'VOD',
      accessLevel: 'DENIED',
      licenceIds: [],
      title: 'When the line is crossed (French subtitles)',
      description:
        'A look into the impact of physical and mental abuse on referees at each level of the game. With first-hand testimonies from top elite referees and football greats like Luís Figo and Esteban Cambiasso. Main conclusion: abuse against referees equals abuse against football.',
      id: 651750,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2024/06/21/8icthFxbJTiYamp3eRzzlYG2xq1UwR19-1718956321097.jpg',
      duration: 690,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2024/06/20/Viwq4fWd3YxLacxphwzepmgsmBhT3rUU-1718918266161/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'When the line is crossed (German subtitles)',
      description:
        'A look into the impact of physical and mental abuse on referees at each level of the game. With first-hand testimonies from top elite referees and football greats like Luís Figo and Esteban Cambiasso. Main conclusion: abuse against referees equals abuse against football.',
      id: 651749,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2024/06/21/PfzQ6ljSwVgXThpjZQJQ82FgilqdmdnT-1718956408875.jpg',
      duration: 690,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2024/06/20/zgnMXdBbvbMG6CVwfwVqJudhY4zItcPT-1718918184165/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'When the line is crossed (Spanish subtitles)',
      description:
        'A look into the impact of physical and mental abuse on referees at each level of the game. With first-hand testimonies from top elite referees and football greats like Luís Figo and Esteban Cambiasso. Main conclusion: abuse against referees equals abuse against football.',
      id: 651748,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2024/06/21/vTwO9DPww3yG8qAUnL3vPyrCoVaL3gDu-1718956479521.jpg',
      duration: 690,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2024/06/20/CNI1vqe8y8ocM94Y95gYofS8Kem81aty-1718918052127/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'When the line is crossed',
      description:
        'A look into the impact of physical and mental abuse on referees at each level of the game. With first-hand testimonies from top elite referees and football greats like Luís Figo and Esteban Cambiasso. Main conclusion: abuse against referees equals abuse against football.',
      id: 648776,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2024/06/11/UrG6zu3zkLO7mq4bXxbJNTG9NfIWlZMM-1718126905212.jpg',
      duration: 690,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2024/06/11/xCIbqjpTyEgV6bHpO7SYeSrfyMniXv7W-1718125701716/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'Trailer: The Extraordinary Story of Miodrag Belodedici',
      description:
        'In October 1988, Miodrag Belodedici defected from the country of his birth. His time as one of Romania’s best-known footballers is over; his time as a fugitive from the state has just begun. As he headed towards Belgrade, what he doesn’t yet know is that he’s also begun an incredible journey that will end with him entering UEFA’s history books as the first man to star and win the European Cup with two clubs. Branded a traitor and a deserter, this is Belodedici’s remarkable story in his own words. The joys of being a footballer, paired with the dangers of escaping his country.',
      id: 596180,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2024/03/13/JZLcZCUgyOlkeW73TlfTFgTyERbTFDD6-1710328161585.jpg',
      duration: 86,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2024/03/13/4XX3iywCmwtypkOrFPsYMAnCPmN7aUtl-1710328048254/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'Trailer: The Extraordinary Story of SEC Bastia',
      description:
        'Of all the French clubs to have reached a major European final, there is one that clearly stands apart. With the ancient symbol of a Moor as their club emblem, a fervent fanbase proud of their distinct cultural heritage, they are a far-flung cry from the six other clubs of the mainland. They are Sporting Club Bastia – the Lions of Furiani. This is the story of football in Corsica, of identity, pride, conflict, and soul, as told through the lens of a memorable run to the to 1978 UEFA Cup Final.',
      id: 596179,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2024/03/13/SK6PMepYht6dnkb1sPlipJwrCjPqZ7yz-1710328199110.jpg',
      duration: 111,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2024/03/13/gsZr8cHlzzL0mPQGeZJP42JDdWlUNvs4-1710328056920/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: "Ballon d'Or",
      description:
        'UEFA and Groupe Amaury join forces to organise the Ballon d’Or, the most prestigious awards ceremony in football.',
      id: 540365,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2023/11/03/NgxgPLV72Tsqf6BR7z2ZjBogAyjDgSez-1699004160613.png',
      duration: 102,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      externalAssetId: '11463005004',
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2023/11/02/4cKYEHIwEFafafCt4FySAMK6oVEbjrOL-1698922226224/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'Outraged - Disability',
      description:
        'Disabled football players, fans and referees explain what football means to them and what they think is needed to improve not just the game but also the match day experience and access to football for everyone. Elite players like Jack Grealish, Sergio Canales and Nicolò Barella meet the fans and players or talk about their own valuable experiences.',
      id: 492415,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2023/06/26/KRtsPcgyrjjzMp0VGMUmsYvpTri5klQb-1687769797744.jpg',
      duration: 847,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2023/06/26/mbE50v0ObsR4wxhpAt52IiZgfykSviTq-1687770314002/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: "Trailer: 'EQUALS' Documentary Series",
      description:
        "EQUALS is a six-part documentary series featuring some of the top stars in the women's game. The series examines the rapid rise of women’s football across Europe as well as the challenges that remain. Watch the full series exclusively on UEFA.tv",
      id: 423834,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2022/12/12/lv30rpLb84ZrQtNGVD8I9zsmHjP5CwrJ-1670856315927.jpg',
      duration: 105,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2022/12/07/lGrKTC5C27mLjaTfK5JIOCfV37MrkgSP-1670422586423/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'Outraged: Football Tackles Discrimination',
      description:
        'Some of the biggest names in the world of football speak out against discrimination in this UEFA Orignals documentary. Hear from the likes of Paul Pogba, Ruud Gullit, Pernille Harder, Megan Rapinoe, and José Mourinho.',
      id: 396790,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2022/09/26/mUQbR4pSR97yx2eeS2SzicBy6Xoewb2o-1664196956013.jpg',
      duration: 3214,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2022/09/26/xLCD4YGkBGMwocc352LY4TLGieyVH7yA-1664196140590/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'Outraged - Online abuse',
      description:
        'Football stars like Wendie Renard, Jorginho, Alisha Lehmann, Karen Carney, Kai Havertz, and Patrick Vieira explain what a devastating impact online abuse can have on footballers, coaches and referees, and what should be done to stop the perpetrators of such hateful acts.',
      id: 376748,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2022/07/18/DR1oLSSOo4taIE4ZM9ie6LQkd4zTxWbW-1658177852863.jpg',
      duration: 693,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2022/07/18/QKhqXwaTlrMS9TFEcDPoZWzFQvRAuA2F-1658177883898/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'Outraged - Racism',
      description:
        'Paul Pogba and Moise Kean talk openly about their experiences with racism in football. Their insights are supported by José Mourinho, Ruud Gullit, Hope Powell, Tyrone Mings and Kalidou Koulibaly.',
      id: 376097,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2022/07/15/HdsLTbsbSrfTZtBrThjbqnqLoskyv71y-1657898787154.jpg',
      duration: 832,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2022/07/15/vYPOjXuYLqYaBECDJxv92GTkxYTbnbEa-1657898822630/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'Outraged - Homophobia',
      description:
        'Georgian footballer Guram Kashia experienced abuse after openly supporting the LGBTQI+ community. His emotional story, together with the experiences of Megan Rapinoe, Pernille Harder, Juan Mata, Thomas Hitzlsperger and Olivier Giroud, sheds a light on the state of LGBTQI+ discrimination in football.',
      id: 376095,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2022/07/15/3uroG6TIsPZblFTntZSKUAZCDqulsMmv-1657898767761.jpg',
      duration: 670,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2022/07/15/9QdVPKkU5GHOpoGfPZB59F7mqy9MYtm2-1657898491291/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'Outraged - Sexism',
      description:
        'Many women still face discrimination and sexism within football. It doesn’t only affect players but also referees, coaches and administrators. Shanice van de Sanden, Megan Rapinoe, Stéphanie Frappart, Hope Powell, Helena Costa, Samantha Johnson and others make a strong case for equal rights and opportunities in football.',
      id: 376094,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2022/07/15/3UAVltx6DJFHJKjAGsfxW2TJ1XJsFwLO-1657898728997.jpg',
      duration: 604,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2022/07/15/BIMr15tooNv6ASId3CorwgteEiMIhmWV-1657898216670/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'Outraged - Refugees',
      description:
        'Dejan Lovren and Nadia Nadim tell their deeply moving stories about fleeing their native countries in wartime and of how football has helped them to process grief, integrate into society and make a new start in life.',
      id: 376093,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2022/07/15/dvtlkzLbYvlnf1H5jaViIEcVbwSHWjm4-1657898750022.jpg',
      duration: 556,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2022/07/15/FLaiZKL8VbViUsPDlekzXZDWJzrOyP8C-1657898183219/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'Coming Soon: A Year Under COVID-19',
      description: '',
      id: 210439,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2021/03/16/obnun0Iy7bNl6kWCp2BNFhDl79q273xm-1615914462520.jpg',
      duration: 30,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2021/03/16/53LRelhOh4rGGQtg5pK0SuqUDeirg54M-1615912260979/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'A Year Under COVID-19',
      description:
        'This insightful documentary looks at some of the key decisions and considerations taken by UEFA in order to keep European club and national team football operational over the last year.',
      id: 210404,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2021/03/16/3PWzmmBDYJd8y9fYf9Cr7apYZ3DwYZh4-1615901497095.jpg',
      duration: 2922,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2021/03/16/5Pd0gDw7Bs1cvpLywkBcugL9pxozkTQH-1615894041508/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'Man In The Middle - Official Trailer',
      description:
        'UEFA will deliver an unprecedented insight into one of the toughest jobs in football with the release of an original documentary series showing up close and personal what it takes to be a Champions League referee. Episode One of ‘Man in the Middle’, a weekly four-part series,  launches on UEFA.tv on 16 November.',
      id: 175363,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2020/11/04/YFdVwv3dM4gme1YFEjd50H60zFwX60Mk-1604478915419.jpg',
      duration: 161,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      externalAssetId: '175363',
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2020/11/03/ptYgFM0WkjykAz8DNLWQeObveVMah0Oy-1604419249617/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'The return of #UEL',
      description:
        'With new dates announced for the remainder of the UEFA Europa League season, we look back at the best moments of the 2019/20 season so far.',
      id: 153820,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2020/06/17/bIEt6oIlJo71ix4MIONLj3akddAvAO1c-1592412040514.jpg',
      duration: 82,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      externalAssetId: '153820:UEL',
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2020/06/17/GJA5U5QbBf2zAumQOI3r80VnpBTbhc9q-1592412025991/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'The #UCL is back!',
      description:
        'With new dates announced for the remainder of the UEFA Champions League season, we look back at the best moments of the 2019/20 season so far.',
      id: 153812,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2020/06/17/9rv3X2D2Vkx5hKHRg8xVSzraUic2ENvU-1592399639275.jpg',
      duration: 98,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      externalAssetId: '153812:UCL',
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2020/06/17/Lf4cyVMrrAYwxkOv9vpX2jw2zGIB5E8U-1592398873258/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
    {
      type: 'VOD',
      accessLevel: 'GRANTED',
      licenceIds: [],
      title: 'Always football. Always on.',
      description: "Here's what you can expect on UEFA.tv",
      id: 84274,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2019/06/07/tdubhP70VovaKm6arMVqGMvFxLAeeQ4b-1559914384355.jpg',
      duration: 129,
      favourite: false,
      watchContext: [],
      offlinePlaybackLanguages: [],
      externalAssetId: '8403330002',
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2023/09/01/2bSXNN0xe4IDhQiB3HVv9JW5kzsFxwLM-1693586137389/bif/preview_thumbnails.bif',
      subEvents: [],
      contentDownload: {
        permission: 'DISALLOWED',
      },
      displayableTags: [],
      computedReleases: [],
      watchStatus: 'NOT_AVAILABLE',
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
      trailers: [],
    },
  ],
  placeholderData: {},
  licences: [],
};
